import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import type { ModalOptions, ItemReorderEventDetail } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CheckboxModalPage } from '@shared/pages';
import {
    CampaignIncentivesService, CampaignIncentiveSetsService, FirebaseFunctionsService
} from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TCampaignIncentiveSet, TCampaignIncentive } from '@shared/models';

@Component({
    'selector': 'app-campaignIncentiveSet',
    'templateUrl': './campaignIncentiveSet.page.html',
    'styleUrls': ['./campaignIncentiveSet.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class CampaignIncentiveSetPage extends ViewBasePage implements OnInit, OnDestroy {
    public vm: any;

    public incentives: TCampaignIncentive[] = [];
    public incentiveSet: TCampaignIncentiveSet;
    // public incentiveSets: TCampaignIncentiveSet[];
    public allSelectableIncentives: any;
    public saveAttempt = false;
    public submitted = false;
    public allIncentives: TCampaignIncentive[];
    public selectedIncentives: TCampaignIncentive[] = [];
    private incentivesSubscription: any;
    private uid = '';

    constructor(private campaignIncentivesService: CampaignIncentivesService,
        private campaignIncentiveSetsService: CampaignIncentiveSetsService,
        private activatedRoute: ActivatedRoute, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_CAMPAIGN_INCENTIVE_SET);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            this.incentiveSet = this.campaignIncentiveSetsService.getNullable();
            this.allIncentives = await this.campaignIncentivesService.getAll();

            this.uid = this.activatedRoute.snapshot.paramMap.get('uid');
            if (this.uid) {
                await this.uxHelperService.showSpinner();

                this.incentiveSet = await this.campaignIncentiveSetsService.getByUid(this.uid);
                this.selectedIncentives = [];
                for (const uid of this.incentiveSet.incentiveUids) {
                    const incentive = await this.campaignIncentivesService.getByUid(uid);
                    this.selectedIncentives.push(incentive);
                }
                await this.uxHelperService.hideSpinner();
            }
            //  else {
            //     this.selectedIncentives = this.allIncentives;
            // }
            this.initMoreMenu();
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            throw new Error('Error in CampaignIncentiveSet.ngOnInit() ');
        }
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-campaign-incentive-set-tour');
    }

    public async openPromptForIncentivesClick(): Promise<void> {
        try {
            // await this.uxHelperService.showSpinner('Checking thousands of zipcodes.');
            // const serviceAreas = this.getNearbyZipcodes(this.dealershipStatecode, this.dealershipCoords, this.serviceArea.radius);
            // await this.uxHelperService.hideSpinner();
            const selectables = this.formatIncentives(this.allIncentives, this.selectedIncentives);
            this.openCheckboxModal(selectables);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    private formatIncentives(allIncentives: TCampaignIncentive[], selectedIncentives: TCampaignIncentive[]): TCampaignIncentive[] {
        const selectables = [];
        const selectedUids = selectedIncentives.map(incentive => incentive.uid);

        allIncentives.forEach((incentive) => {
            const isSelected = selectedUids.includes(incentive.uid);
            selectables.push({
                'title': incentive.title,
                'line1': incentive.title,
                // 'line1': incentive.line1,
                'line2': incentive.line1,
                'note': incentive.note,
                'sequenceNumber': incentive.sequenceNumber,
                'uid': incentive.uid,
                'selected': (isSelected)
            });
        });

        return selectables;
    }

    private async openCheckboxModal(selectables: any) {
        const options: ModalOptions = {
            'component': CheckboxModalPage,
            'componentProps': {
                'selectables': selectables,
                // 'items': items, 
                'title': 'Select Incentives For This Set',
                'showTestCustomerButton': false
            },
            'backdropDismiss': true,
            'showBackdrop': true,
            'cssClass': 'campaignCheckboxModal'
        };

        const myModal = await this.modalController.create(options);
        myModal.onDidDismiss()
            .then((response: any) => {
                if (response.data.okay) {
                    this.selectedIncentives = [];
                    response.data.selectedItems.forEach(item => {
                        const incentive = this.allIncentives.find(c => (c.uid === item.uid));
                        if (incentive) {
                            this.selectedIncentives.push(incentive);
                        }
                    });
                    // this.selectedIncentives = response.data.selectedItems;
                }
            });

        myModal.present();
    }

    // private async openCheckboxModal(selectables  /*, items */) {
    //     const options: ModalOptions = {
    //         'component': CheckboxModalPage,
    //         'componentProps': {
    //             'selectables': selectables,
    //             // 'items': items, 
    //             'title': 'Select Customers',
    //             'showTestCustomerButton': true
    //         },
    //         'backdropDismiss': true,
    //         'showBackdrop': true,
    //         'cssClass': 'myModalSize'
    //     };

    //     const myModal = await this.modalController.create(options);
    //     myModal.onDidDismiss()
    //         .then((response: any) => {
    //             if (response.data.okay) {
    //                 this.allSelectedIncentives = response.data.selectedItems;
    //             }
    //         });

    //     myModal.present();
    // }

    // Move the incentive from one position to another.
    // public onIncentiveMove(ev: CustomEvent<ItemReorderEventDetail>) {
    public onIncentiveMove(ev: any): void {
        try {
            ev.detail.complete(this.selectedIncentives);

            // let idx = 0;
            // this.selectedIncentives.forEach(incentive => {
            //     incentive.sequenceNumber = ++idx;
            // });
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    /*
        public onMoveLeg(ev) {
            // console .log(ev);
            const from = ev.detail.from;
            const to = ev.detail.to;
    
            this.swapLegPositions(from, to);
            const status = this.ensureSeatAvailability();
    
            if (status) {
                this.vm.routeLegs = this.navigationHelperService.buildRouteLegs(
                    this.vm.startingPoint, this.vm.endingPoint, this.vm.selectedTickets);
            } else {
                const msg = 'This route doesnt allow for enough seats. Resetting to the previous route configuration ';
                this.uxHelperService.showAlert('Invalid Route Configuration', msg);
                this.swapLegPositions(to, from);
            }
            ev.detail.complete();
        }
    */
    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Saving.  Please wait...');

            const incentiveUids: string[] = [];
            this.selectedIncentives.forEach(incentive => {
                incentiveUids.push(incentive.uid);
            });
            const campaignIncentiveSet: TCampaignIncentiveSet = {
                'setName': this.incentiveSet.setName,
                'incentiveSetId': this.incentiveSet.incentiveSetId,
                'incentiveUids': incentiveUids,
                'uid': this.uid
            };

            if (this.uid) {
                await this.campaignIncentiveSetsService.update(campaignIncentiveSet);
            } else {
                campaignIncentiveSet.incentiveSetId = await this.firebaseFunctionsService.getNextIncentiveSetId();
                await this.campaignIncentiveSetsService.add(campaignIncentiveSet);
            }
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Saved.');
            this.router.navigateByUrl('/marketing/campaignIncentiveSets');
        }
    }
}
